import './App.css';
import Home from './Components/Home';
import Navbar from './Components/Navbar';

function App() {
  return (
    <div className=''>
      <Navbar></Navbar>
      <Home></Home>
    </div>
  );
}

export default App;
